const NAMESPACE = 'DUCKS/TRIPS';

export default NAMESPACE;
